import AuthService from '@src/helpers/authService'
import { handleErrorNotification } from '@src/helpers/ErrorHandlingService/ErrorHandlingService'
import {
  IMyUpshifter,
  SORTING_DIRECTION,
  TGetMyUpshiftersParams,
} from '@src/models/MyUpshifter'
import { API } from '@src/network'
import { useCallback, useEffect, useState } from 'react'

export const useRosterMembersData = (rosterId: number, isExpanded: boolean) => {
  const businessId = AuthService.getBusinessEntity()?.id
  const [isFetching, setIsFetching] = useState(false)
  const [members, setMembers] = useState<IMyUpshifter[]>()

  const fetchMembers = useCallback(async () => {
    try {
      setIsFetching(true)
      const params: TGetMyUpshiftersParams = {
        business_id: businessId,
        roster_ids: [rosterId],
        order_by: 'hours_worked_last_month_or_year',
        order_by_direction: SORTING_DIRECTION.DESC,
        include: {
          last_completed_punch_card: {
            business_id: businessId,
          },
          finished_punch_cards_sum_hours_total: {
            business_id: businessId,
          },
          finished_punch_cards_thirty_trailing_days_sum_hours_total:
            'finished_punch_cards_thirty_trailing_days_sum_hours_total',
        },
      }
      const response = await API.MyUpshifters.getMyUpshifters(params)
      setMembers(response.data)
    } catch (error) {
      handleErrorNotification(error)
    } finally {
      setIsFetching(false)
    }
  }, [businessId, rosterId])

  useEffect(() => {
    if (isExpanded && !isFetching && !members) {
      fetchMembers()
    }
  }, [fetchMembers, isExpanded, isFetching, members])

  return { isFetching, members }
}
